<template lang="pug">
v-container(my-8 py-8 fluid)
  v-layout(text-xs-left='', wrap='')
    v-flex(xs11='' offset-xs1)
      h1.title-all 18歲缺角的參與政事權利
    v-flex.rights-chart(xs12='' md6)
      span.tooltiptext#tooltip(v-html="message")
      // ve-pie(:data='chartData' :settings="chartSettings" :tooltip-visible="true" :judge-width="true" :legend-visible="false" :tooltip="tooltip")
      // ?xml version="1.0" encoding="UTF-8"?
      svg.chart(width='528px', height='520px', viewBox='0 0 528 520', version='1.1', xmlns='http://www.w3.org/2000/svg', xmlns:xlink='http://www.w3.org/1999/xlink')
        // Generator: Sketch 52.5 (67469) - http://www.bohemiancoding.com/sketch
        title chart
        desc Created with Sketch.
        g#Page-1(stroke='none', stroke-width='1', fill='none', fill-rule='evenodd')
          g#Artboard(transform='translate(-250.000000, -230.000000)')
            g#chart(transform='translate(517.513580, 494.538618) rotate(37.000000) translate(-517.513580, -494.538618) translate(257.013580, 229.038618)')
              path#Segment1.Segment(d='M250.003889,280.003471 C250.003889,280.003471 250.003889,280.003471 250.003889,280.003471 C250.003889,280.003471 250.003889,280.003471 250.003889,280.003471 L12.2438887,357.253471 C39.8438887,442.193471 110.663889,505.973471 198.023889,524.543471 C215.113889,528.173471 232.533889,530.003471 250.003889,530.003471 L250.003889,280.003471 Z', fill='#C4BEC6')
              path#Segment2.Segment(d='M250.003889,280.003471 C250.003889,280.003471 250.003889,280.003471 250.003889,280.003471 C250.003889,280.003471 250.003889,280.003471 250.003889,280.003471 L103.053889,77.753471 C30.7938887,130.253471 -7.9661113,217.303471 1.3738887,306.133471 C3.2038887,323.503471 6.8438887,340.643471 12.2438887,357.253471 L250.003889,280.003471 Z', fill='#C4BEC6')
              path#Segment3.Segment(d='M257.95,250.003471 C257.95,250.003471 257.95,250.003471 257.95,250.003471 C257.95,250.003471 257.95,250.003471 257.95,250.003471 L404.9,47.753471 C332.64,-4.74652902 237.86,-14.716529 156.27,21.613471 C140.31,28.723471 125.13,37.483471 111,47.753471 L257.95,250.003471 Z', fill='#C4BEC6')
              path#Segment4.Segment(d='M270,262.25 C270,262.25 270,262.25 270,262.25 C270,262.25 270,262.25 270,262.25 L507.76,339.5 C535.36,254.56 515.55,161.35 455.79,94.97 C444.1,81.99 431.08,70.27 416.95,60 L270,262.25 Z', fill='#C4BEC6')
              path#Segment5.Segment(d='M250.003889,280.003471 L250.003889,530.003471 C339.323889,530.003471 421.853889,482.353471 466.513889,405.003471 C475.243889,389.873471 482.363889,373.863471 487.763889,357.253471 L250.003889,280.003471 Z', fill='#C4BEC6')
              text(id='選舉權-20歲', transform='translate(257.950000, 105.259821) rotate(-37.000000) translate(-257.950000, -105.259821) ', font-family='PingFangTC-Medium, PingFang TC', font-size='30', font-weight='400', fill='#FFFFFF')
                tspan(x='212.95', y='91.2598215') 選舉權
                tspan(x='218.35', y='133.259821', font-size='36') 20歲
              text(id='被選舉權-23歲', transform='translate(404.900000, 217.503471) rotate(-37.000000) translate(-404.900000, -217.503471) ', font-family='PingFangTC-Medium, PingFang TC', font-size='30', font-weight='400', fill='#FFFFFF')
                tspan(x='344.9', y='203.503471') 被選舉權
                tspan(x='365.3', y='245.503471', font-size='36') 23歲
              text(id='18歲-應考試-服公職權力', transform='translate(329.298378, 405.003471) rotate(-37.000000) translate(-329.298378, -405.003471) ', font-family='PingFangTC-Medium, PingFang TC', font-size='36', font-weight='400', line-spacing='40', fill='#FFFFFF')
                tspan(x='292.722378', y='383.003471') 18歲
                tspan(x='367.602378', y='384.275471', font-size='30')
                tspan(x='284.298378', y='424.275471', font-size='30') 應考試
                tspan(x='254.298378', y='464.275471', font-size='30') 服公職權力
              text(id='18歲-複決權', transform='translate(156.124016, 403.318910) rotate(-37.000000) translate(-156.124016, -403.318910) ', font-family='PingFangTC-Medium, PingFang TC', font-size='36', font-weight='400', fill='#FFFFFF')
                tspan(x='119.980016', y='395.31891') 18歲
                tspan(x='192.268016', y='395.31891', font-size='30')
                tspan(x='111.124016', y='445.31891', font-size='30') 複決權
              text(id='創制權-18歲', transform='translate(104.048564, 232.897640) rotate(-37.000000) translate(-104.048564, -232.897640) ', font-family='PingFangTC-Medium, PingFang TC', font-size='30', font-weight='400', fill='#FFFFFF')
                tspan(x='59.0485645', y='218.89764') 創制權
                tspan(x='67.9045645', y='260.89764', font-size='36') 18歲

    v-flex.rights-content(xs10='' offset-xs1 offset-md0 md5)
      span.content-all 在我國《憲法》及1967年簽署、2008年內國法化的《公民與政治權利國際公約》明定：我國人民享有的參與政事的權利，包括：選舉、被選舉、創制、複決、應考試服公職。
      br
      br
      span.content-all 各個參與政事權利的門檻限制，規定於不同的法律中，除了明定於《憲法》第130條的選舉權、被選舉權外，其他參政權利皆隨著時代進步，陸續調整放寬年齡門檻，導致依現行法令 <u>18歲青年只有創制、複決及應考及服公職的權利，無選舉／罷免、被選舉等，仍是缺角且不完整的公民參政權利</u>。
      br
      br
      span.content-all 即使各界已發現我國民主憲政體制權責不符、運作不完善，仍無法隨國際民主潮流前進的關鍵不成功因素，被認為是<u>高門檻的修憲程序及通過標準（2005年，憲法增修條文第12條）</u>。
</template>

<script>
export default {
  data() {
    return {
      message: "hi",
      data: [
        {
          title: "創制權、複決權",
          content:
            "我國《憲法》第 136 條，創制複決兩權之行使，以法律定之，後規定於《公民投票法》第7條。<br><br>2003年公布施行：中華民國國民，年滿二十歲，無下列情事之一者，有公民投票權：<br><br>2018年修正公布施行：中華民國國民，除憲法另有規定外，年滿十八歲，未受監護宣告者，有公民投票權。"
        },
        {
          title: "創制權、複決權",
          content:
            "我國《憲法》第 136 條，創制複決兩權之行使，以法律定之，後規定於《公民投票法》第7條。<br><br>2003年公布施行：中華民國國民，年滿二十歲，無下列情事之一者，有公民投票權：<br><br>2018年修正公布施行：中華民國國民，除憲法另有規定外，年滿十八歲，未受監護宣告者，有公民投票權。"
        },
        {
          title: "選舉權",
          content:
            "我國規定於《憲法》第130條，中華民國國民年滿二十歲者，有依法選舉之權。1947年制定，迄今尚未修正。"
        },
        {
          title: "被選舉權",
          content:
            "我國規定於《憲法》第130條，除本憲法及法律別有規定者外，年滿二十三歲者，有依法被選舉之權。1947年制定，迄今尚未修正。"
        },
        {
          title: "應考試、服公職權力",
          content:
            "《憲法》第 85 條，公務人員之選拔，應實行公開競爭之考試制度。<br><br>《憲法》第86條，公務人員任用資格、專門職業及技術人員執業資格應應經考試院依法考選銓定之，我國規定於《公務人員考試法》與各個國家考試規定。<br><br>1986年制定，無明確年齡規定，最低明定國民中學畢業（推論約15歲）<br><br>1996年起修正公布，第7、17條明訂18歲，後續逐年討論多次修正。",
          theme: "dark"
        }
      ],
      dialog: false,
      dialogTitle: "",
      dialogContent: "",
      textContent: [
        "<h3>選舉權</h3><br><br>我國規定於《憲法》第130條，中華民國國民年滿二十歲者，有依法選舉之權。1947年制定，迄今尚未修正。",
        "<h3>被選舉權</h3><br><br>我國規定於《憲法》第130條，除本憲法及法律別有規定者外，年滿二十三歲者，有依法被選舉之權。<br><br>1947年制定，迄今尚未修正。",
        "<h3>創制權、複決權</h3><br><br>我國《憲法》第 136 條，創制複決兩權之行使，以法律定之，後規定於《公民投票法》第7條。<br><br>2003年公布施行：中華民國國民，年滿二十歲，無下列情事之一者，有公民投票權：<br><br>2018年修正公布施行：中華民國國民，除憲法另有規定外，年滿十八歲，未受監護宣告者，有公民投票權。",
        "<h3>應考試、服公職權力</h3><br><br>《憲法》第 85 條，公務人員之選拔，應實行公開競爭之考試制度。<br><br>《憲法》第86條，公務人員任用資格、專門職業及技術人員執業資格應應經考試院依法考選銓定之，我國規定於《公務人員考試法》與各個國家考試規定。<br><br>1986年制定，無明確年齡規定，最低明定國民中學畢業（推論約15歲）<br><br>1996年起修正公布，第7、17條明訂18歲，後續逐年討論多次修正。"
      ],
      chartData: {
        columns: ["參政權利", "比例"],
        rows: [
          { 參政權利: "選舉權\n\n（20歲）", 比例: 1 },
          { 參政權利: "被選舉權\n\n（23歲）", 比例: 1 },
          { 參政權利: "創制權、\n複決權\n\n（18歲）", 比例: 1 },
          { 參政權利: "應考試、\n服公職權力\n\n（18歲）", 比例: 1 }
        ]
      },
      chartColors: ["#87a997", "#d49ea2", "#5b4947"],
      chartExtend: {}
    };
  },
  methods: {
    hideTooltip(event) {
      var eventId = event.target.id;
      var tooltip = document.getElementById("tooltip");
      return tooltip.classList.remove("active");
    },
    handleMouseMove(event) {
      var eventId = event.target.id;
      var tooltip = document.getElementById("tooltip");
      if (window.innerWidth < 680) {
        return tooltip.classList.remove("active");
      }
      switch (eventId) {
        case "Segment1":
          this.message = this.data[0].content;
          break;
        case "Segment2":
          this.message = this.data[1].content;
          break;
        case "Segment3":
          this.message = this.data[2].content;
          break;
        case "Segment4":
          this.message = this.data[3].content;
          break;
        case "Segment5":
          this.message = this.data[4].content;
          break;
        default:
          return tooltip.classList.remove("active");
      }

      var x = event.clientX;
      var y = event.clientY;

      tooltip.style.left = x + 20 + "px";
      tooltip.style.top = y - 20 + "px";
      tooltip.classList.add("active");
      tooltip.style.maxWidth = window.innerWidth - x - 30 + "px";
    }
  },
  mounted() {
    document
      .querySelector("svg.chart")
      .addEventListener("mousemove", this.handleMouseMove, false);

    document
      .querySelector("svg.chart")
      .addEventListener("mouseleave", this.hideTooltip, false);
  }
};
</script>

<style lang="scss" scoped>
.tooltiptext {
  display: none;
  width: 40vw;
  padding: 20px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  position: fixed;
  z-index: 1;
}

.tooltiptext.active {
  display: initial;
}

.rights-content {
  margin: auto;
}

.rights-chart {
  position: relative;
}

.rights-chart {
  display: flex;
  align-items: center;
  justify-content: center;
  .chart {
    width: 80%;
    max-width: 450px;
  }
}

.Segment {
  &:after {
    color: white;
    content: " ";
    position: absolute;
    width: 100vw;
    height: 100vh;
    background-color: red;
    right: 10px;
    top: 0;
    z-index: 100;
  }
  &:hover {
    // fill: gray !important;
  }
}

#Segment1 {
  fill: #f7d84f;
}

#Segment2 {
  fill: #56a9e0;
}

#Segment3,
#Segment4 {
  fill: gray;
}

#Segment5 {
  fill: #c143c1;
}
</style>
